import { render, staticRenderFns } from "./wsNavigationHeader.vue?vue&type=template&id=21493632&scoped=true&"
import script from "./wsNavigationHeader.vue?vue&type=script&lang=js&"
export * from "./wsNavigationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21493632",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSheet,VSimpleTable})
